import interactionParserUtils from '../../qti/parser/question/interactions/InteractionParserUtils';
import xmlDomUtils from '../../qti/utils/XmlDomUtils';
import feedbackService from '../../services/FeedbackService';
import { t } from '../../services/i18nService';


const feedbackOutcomeSelector = {
    getAllConcatedVariables(outcomeVariables, templateDeclarations) {
        if (!outcomeVariables) {
            return templateDeclarations;
        }

        const additionalVariables = Object.keys(outcomeVariables).reduce((acc, item) => {
            if (item.includes('response')) {
                outcomeVariables[item].value = [outcomeVariables[item].value];
                acc.push(outcomeVariables[item]);
            }

            return acc;
        }, []);

        return [...templateDeclarations, ...additionalVariables];
    },

    getOutcomeValueForInteraction(prefix, identifier, outcomeVariables) {
        if (outcomeVariables) {
            const outcomeObject = outcomeVariables[`${prefix}_${identifier}`];
            return outcomeObject ? outcomeObject.value : undefined;
        }
        return undefined;
    },

    getParsedFeedbackForResponse(props) {
        const {
            feedback,
            question: {
                language,
                supportedLanguages,
                templateDeclarations,
            },
            outcomeVariables,
        } = props;

        if (!feedback) {
            return null;
        }

        const element = xmlDomUtils.getElementFromString(feedback);
        let languageNode = interactionParserUtils.getLanguageNodeForFeedback(element, language, supportedLanguages);

        if (!languageNode) {
            const childNodesToString = Array.from(element?.childNodes).map(node => xmlDomUtils.stringify(node)).join('').trim();
            const wrappedChildNodes = xmlDomUtils.getElementFromString(`<div>${childNodesToString}</div>`);

            languageNode = wrappedChildNodes;
        }

        if (!feedbackService.shouldRenderFeedback(languageNode)) return null;

        return interactionParserUtils.replaceVariablesAndSerializeFeedback(
            languageNode,
            this.getAllConcatedVariables(outcomeVariables, templateDeclarations),
            true
        );
    },

    userCanViewRightWrong(correctResponsesForInteraction) {
        return !!correctResponsesForInteraction;
    },

    isAttempted(userResponse) {
        return userResponse !== undefined && userResponse !== '';
    },

    getResponseModel(question, identifier) {
        return question.responseModels.find(item => item.identifier === identifier);
    },

    selectProps(ownProps) {
        const {
            correctResponsesForInteraction,
            question,
            identifier,
            outcomeVariables,
            correctResponses,
            userResponses,
            feedback,
        } = ownProps;

        const inlineFeedback = this.getParsedFeedbackForResponse(ownProps);
        const feedbackHeaderCaption = t('questionFeedback.headerForResponse');
        const isPartiallyCorrect = this.getOutcomeValueForInteraction('isPartiallyCorrect', identifier, outcomeVariables) === 'true';
        const isCorrect = this.getOutcomeValueForInteraction('isCorrect', identifier, outcomeVariables) === 'true';
        const userResponse = userResponses[identifier];
        const showOutcomeIconIndicators = this.userCanViewRightWrong(correctResponsesForInteraction);
        const responseModel = this.getResponseModel(question, identifier);
        const isAttempted = this.isAttempted(userResponse);
        const correctResponsesData = showOutcomeIconIndicators && correctResponses ?
            correctResponses[identifier] :
            undefined;
        const hasValidResponseFeedback = feedbackService.hasValidResponseFeedback(identifier, question, feedback);

        return {
            inlineFeedback,
            feedbackHeaderCaption,
            isPartiallyCorrect,
            isCorrect,
            userResponse,
            showOutcomeIconIndicators,
            responseModel,
            isAttempted,
            correctResponsesData,
            hasValidResponseFeedback,
        };
    },
};

export default feedbackOutcomeSelector;
